// src/components/ZodiyakBubble.tsx hardened/refactored v1

type ZodiyakBubbleProps = {
  children: React.ReactNode;
};

const INK = "#1A1A1A";

const bubbleStyle: React.CSSProperties = {
  position: "relative",
  background: "#FFFFFF",
  border: `3px solid ${INK}`,
  borderRadius: 20,
  boxShadow: `4px 4px 0px ${INK}`,
  padding: 16,
  marginRight: 8,
  // Default brand typography — children that set their own font/color win
  // via the cascade; this just gives unstyled children a sensible default.
  fontFamily: "'Fredoka', sans-serif",
  fontSize: 18,
  fontWeight: 600,
  color: INK,
};

// Outer (ink) triangle — sits behind the inner white triangle so the bubble
// reads as an outlined speech tail. Pointing left, anchored to bubble's
// bottom-left.
const outerTailStyle: React.CSSProperties = {
  position: "absolute",
  bottom: 16,
  left: -24,
  width: 0,
  height: 0,
  borderTop: "18px solid transparent",
  borderRight: `24px solid ${INK}`,
  borderBottom: "18px solid transparent",
};

const innerTailStyle: React.CSSProperties = {
  position: "absolute",
  bottom: 16,
  left: -13,
  width: 0,
  height: 0,
  borderTop: "15px solid transparent",
  borderRight: "21px solid #FFFFFF",
  borderBottom: "15px solid transparent",
};

export function ZodiyakBubble({ children }: ZodiyakBubbleProps) {
  return (
    <div style={{ position: "relative" }}>
      <div style={bubbleStyle}>
        {children}

        {/* Pointer tail — outer ink triangle then inner white inset */}
        <div style={outerTailStyle} aria-hidden="true" />
        <div style={innerTailStyle} aria-hidden="true" />
      </div>
    </div>
  );
}
